import { Shield } from '@phosphor-icons/react';

import { WizardEduBlock, WizardStepHeader } from '../wizard';
import pt from '../../locales/pt';

export function EmergencyFundIntroStep() {
  const copy = pt.emergencyFund.wizard.intro;

  return (
    <div className="flex flex-col gap-4">
      <WizardStepHeader
        eyebrow={copy.eyebrow}
        title={copy.title}
        subtitle={copy.subtitle}
      />
      <WizardEduBlock icon={Shield} badgeLabel={copy.howItWorks} body={copy.body} points={copy.points} />
    </div>
  );
}

export default EmergencyFundIntroStep;
